import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'bam-blog-teaser-item',
  styleUrl: 'bam-blog-teaser-item.scss',
  shadow: false,
})
export class BamBlogTeaserItem {
  @Element() el: HTMLElement;

  @Prop() is_big?: boolean = false;
  @Prop({ mutable: true }) category?: string;
  @Prop({ mutable: true }) date?: string;
  @Prop({ mutable: true }) headline_short?: string;
  @Prop({ mutable: true }) headline?: string;
  @Prop({ mutable: true }) subline?: string;
  @Prop({ mutable: true }) button_target?: string;
  @Prop({ mutable: true }) button_text?: string;
  @Prop() hasImageOnLoadMore?: boolean = false;
  @Prop() response?: object;
  @Prop({ mutable: true }) srcSet?: string;
  @Prop({ mutable: true }) src?: string;
  @Prop({ mutable: true }) imgAlt?: string;
  @Prop() isInWidget = false;

  connectedCallback() {
    if (this.hasImageOnLoadMore && !!this.response) {
      // Set props for items from "load more" event
      const keys = [...Object.keys(this.response)];
      keys.forEach(key => {
        this[key] = this.response[key];
      });

      if (this.response['image']) {
        if (this.response['image']['srcset']) {
          this.srcSet = JSON.stringify(this.response['image']['srcset']);
        } else {
          this.src = this.response['image']['src'];
        }
        this.imgAlt = this.response['image']['alt'];
      }
    }

    if (!!this.headline) {
      this.headline = this.truncateString(this.headline, this.is_big ? 140 : 80);
    }

    if (!!this.subline) {
      const sublineLimit = this.truncateString(this.headline, this.is_big ? 140 : 80).length > 50 ? 110 : 160;
      this.subline = this.truncateString(this.subline, this.is_big ? 320 : sublineLimit);
    }
  }

  truncateString = (string: string, limit: number) => {
    return string.length > limit ? string.slice(0, limit - 1) + '...' : string;
  };

  render() {
    const { is_big, category, date, headline_short, headline, subline, button_target, button_text, hasImageOnLoadMore } = this;

    return (
      <Host
        app-widget={this.isInWidget}
        data-tracking-style={this.el.dataset.trackingStyle || 'cta'}
        data-tracking-topic={this.el.dataset.trackingTopic || button_text}
        data-tracking-context={this.el.dataset.trackingContext || 'newsBlogsTeaser'}
        data-tracking-id={this.el.dataset.trackingId || `${headline}#${this.el.dataset.trackingContext || 'newsBlogsTeaser'}`}
      >
        {(this.src || this.srcSet) && (
          <div class="bam-blog-teaser-item__image-wrapper">
            {hasImageOnLoadMore ? (
              <a href={button_target}>
                <bam-image {...(this.srcSet ? { srcSet: this.srcSet } : { image: this.src })} hasRoundedBorder="12" alt-image={this.imgAlt} isAnimated={true}></bam-image>
              </a>
            ) : (
              <a href={button_target}>
                <slot name="image"></slot>
              </a>
            )}
          </div>
        )}
        <bal-card class="bam-blog-teaser__item-box bal-card bal-card--is-white" {...(is_big && { flat: true })} aria-label={headline}>
          <bal-card-content class="bal-card-content flex flex-direction-column">
            {!!category && (
              <bal-tag color="grey" size="small">
                {category}
              </bal-tag>
            )}
            <bal-text class="is-date">{date}</bal-text>

            {is_big ? (
              <div>
                <bal-heading level="h3" space="bottom" class="mobile:is-hidden">
                  {headline}
                </bal-heading>
                <bal-heading level="h3" space="bottom" class="tablet:is-hidden">
                  {headline_short}
                </bal-heading>
                {!!this.subline && <bal-text class="mb-normal">{subline}</bal-text>}
                <bal-button color="primary" class="mt-x-small is-lead" href={button_target} onClick={event => window.track(event)}>
                  {button_text}
                </bal-button>
              </div>
            ) : (
              [
                <div class="bal-card-content-text bam-blog-teaser__item-box-content-wrapper">
                  <bal-heading level="h3" visualLevel="h5" space="bottom">
                    {headline}
                  </bal-heading>
                  {!!this.subline && <bal-text class="mb-normal std-mobile">{subline}</bal-text>}
                </div>,
                <bal-card-button class="p-none" color="info" href={button_target} onClick={event => window.track(event)}>
                  {button_text}
                </bal-card-button>,
              ]
            )}
          </bal-card-content>
        </bal-card>
      </Host>
    );
  }
}
